import { Platform } from 'react-native';

import { type EventObject, fromCallback, fromPromise } from 'xstate';

import { idMeConfig } from '../../config';
import {
  createIdMeAuthorizationRequest,
  promptIdMeAuthorization,
  signOutOfIdMe,
} from '../../helpers';

import type { IdMeAuthorizationRequest } from '../../idme.types';
import type { VerificationResult, VerifiedGroups } from './types';

// ─── Internal Actors ─────────────────────────────────────────────────────────

export const createAuthorizationRequest = fromPromise(async () =>
  createIdMeAuthorizationRequest({ scopes: idMeConfig.scopes }),
);

/**
 * NOTE: Native authorizes in `IdMeAuthorizationWebView`, which sends `AUTHORIZATION_RESULT` itself.
 */
export const promptAuthorization = fromCallback<EventObject, IdMeAuthorizationRequest | undefined>(
  ({ input, sendBack }) => {
    if (Platform.OS !== 'web') {
      return;
    }

    if (!input) {
      return;
    }

    void promptIdMeAuthorization(input).then((result) => {
      sendBack({ type: 'AUTHORIZATION_RESULT', result });
    });
  },
);

export const signOut = fromPromise(async () => signOutOfIdMe());

// ─── External Actors ─────────────────────────────────────────────────────────

export const fetchVerifiedGroups = fromPromise<VerifiedGroups>(async () => {
  throw new Error('`fetchVerifiedGroups` actor is not provided.');
});

export const verifyGroup = fromPromise<VerificationResult, VerifyGroupParams>(async () => {
  throw new Error('`verifyGroup` actor is not provided.');
});

// ─── Types ───────────────────────────────────────────────────────────────────

type VerifyGroupParams = {
  request: IdMeAuthorizationRequest | undefined;
  code: string | undefined;
};
